<template>
  <div class="content">
    <div v-if="!loading && !error && policy">
      <p>{{ $t("passwordPolicy.requirements") }}</p>
      <div class="content">
        <ul>
          <li v-if="policy.requiredLength">{{ $t('passwordPolicy.minLength') }}: <strong>{{ policy.requiredLength }}</strong> </li>
          <li v-if="policy.maxLength">{{ $t('passwordPolicy.maxLength') }}: <strong>{{ policy.maxLength }}</strong></li>
          <li v-if="policy.requireDigit">{{ $t('passwordPolicy.requireDigit') }}</li>
          <li v-if="policy.requireLowercase">
        <template
          v-if="
            policy.lowercaseAlphabets && policy.lowercaseAlphabets.length > 0
          "
        >
          {{ $t("passwordPolicy.requireLowercase") }}: <strong>{{ lowercaseAlphabets }}</strong>
        </template>
        <template v-else>
          {{ $t("passwordPolicy.requireLowercase") }}
        </template>
      </li>
      <li v-if="policy.requireUppercase">      
      <template
          v-if="
            policy.uppercaseAlphabets && policy.uppercaseAlphabets.length > 0"
        >
          {{ $t("passwordPolicy.requireUppercase") }}: <strong>{{uppercaseAlphabets}}</strong>
        </template>
        <template v-else>
          {{ $t("passwordPolicy.requireUppercase") }}
        </template>
      </li>
          <li v-if="policy.requireSpecialCharacters">{{ $t('passwordPolicy.requireSpecialCharacters') }} </li>
          <li v-if="policy.specialCharacters">{{ $t("passwordPolicy.allowedSpecialCharacters") }}: <strong>{{ policy.specialCharacters }}</strong></li>
          <li v-if="policy.minPasswordDifference && policy.minPasswordDifference > 0">{{$t("passwordPolicy.minChangedSymbols")}}: <strong>{{policy.minPasswordDifference}}</strong></li>
          <li v-if="policy.allCharactersMustBeUnique">{{ $t("passwordPolicy.allCharactersMustBeUnique") }} </li>                   
        </ul>
      </div>
    </div>
    <div v-if="error" class="has-text-warning">{{ error }}</div>
    <div v-if="loading">{{ $t("passwordPolicy.loading") }}</div>
  </div>
</template>

<script>
import policy from "@/services/policy";

export default {
  name: "PasswordPolicyInfo",
  data() {
    return {
      policy: undefined,
      loading: false,
      error: undefined      
    }
  },
  methods: {
    fetch() {
      this.loading = true;
      this.error = undefined;
      policy.getPasswordPolicy().then(resp => {
        this.loading = false;
        if (!resp || !resp.data) {
          throw new Error();
        }
        this.policy = resp.data;
        this.policyFetched();
      }).catch(err => {
        this.loading = false;
        if (err && err.message) {
          this.error = err.message;
        } else {
          this.error = this.t('defaultErr');
        }
      })
    },
    alphabetToString(requireCase, alphabet) {
      return requireCase && alphabet.required
        ? alphabet.letters + "*"
        : alphabet.letters;
    },
    policyFetched() {
      this.$emit('policyFetched', this.policy);
    },
  },
  computed: {
    uppercaseAlphabets() {
      return this.policy.uppercaseAlphabets
        .map((_) => this.alphabetToString(this.policy.requireUppercase, _))
        .join(", ");
    },
    lowercaseAlphabets() {
      return this.policy.lowercaseAlphabets
        .map((_) => this.alphabetToString(this.policy.requireLowercase, _))
        .join(", ");
    },
  },
  mounted() {
    this.fetch()
  }
}
</script>


